import { useQuery } from "graphql-hooks";
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Col, Row } from 'reactstrap';
import { PermissionsGate } from '../../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../../utilities/constValues';
import Helper from '../../../utilities/helper';
import { ErrorPage } from '../../Shared/ErrorPage';
import { Hero } from "../../Shared/Hero";
import { Loading } from '../../Shared/Loading';
import { MetaTags } from '../../Shared/MetaTags';
import { NavigationCardSet } from '../../Shared/NavigationCards/NavigationCardSet';
import { PermissionsRequired } from '../../Shared/PermissionsRequired';
import { Basics } from "./Basics";
import { Costs } from "./Costs";
import { Installation } from "./Installation";
import { OperationAndMaintenance } from "./OperationAndMaintenance";
import { SecurityAndProtection } from "./SecurityAndProtection";
import { AnchorLink, PageAnchors } from "../../Shared/PageAnchors";
import { useAPIErrorContext } from '../../../contexts/apiErrorContext';


const CMS_QUERY = `query datoQuery {
    pageData: pageElectricVehicleSupplyEquipment {
        fieldHeroTitle
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
    websiteConfiguration {
        fieldWebsiteTitle
    }
}`;

export const ElectricVehicleSupplyEquipment = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();
    const location = useLocation();
    const pageAnchors: AnchorLink[] = [{ displayName: "Basics", hashLocation: "./#basics" },
        { displayName: "Costs", hashLocation: "./#costs" },
        { displayName: "Installation", hashLocation: "./#installation" },
        { displayName: "Operation and Maintenance", hashLocation: "./#operation-and-maintenance" },
        { displayName: "Security and Protection", hashLocation: "./#security-and-protection" }];

    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.ElectricVehicleSupplyEquipment}>
                <div className="electricVehicleSupplyEquipment">
                    <Hero pageTitle={data.pageData.fieldHeroTitle} />
                    <PageAnchors anchorLinks={pageAnchors} />
                    <Basics/>
                    <Costs />
                    <Installation />
                    <OperationAndMaintenance />
                    <SecurityAndProtection />
                    <NavigationCardSet PageData={data.pageData} />
                    <MetaTags seoData={data.pageData.seo} />

                </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
